import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/index",
    name: "index",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/index/index.vue"),
  },
  {
    path: "*",
    name: "default",
    redirect: "/index",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
